import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — ceramic tile floor. Same 1x1 m / 0.06-thick slab convention as
// floor-wood; the grout lines are thin flush overlays on the slab top.
const CERAMIC = "#d6d3cc";
const GROUT = "#b8b2a8";

export const floorTile = defineModel({
  id: "floor-tile",
  batchId: "modern",
  name: "Ceramic tile floor",
  tags: ["modern", "interior", "structure", "floor", "tile"],
  summary: "A 1x1 light-grey ceramic tile floor with grout lines.",
  description:
    "A one-tile ceramic floor slab of the Modern Living kit: exactly 1x1 m " +
    "and 0.06 m thick, with thin grout strips dividing it into a 3x3 tile " +
    "read. Tiles seamlessly against every other ground piece.",
  tiles: { w: 1, h: 1 },
  footprint: 0.75,
  parts(): Part[] {
    const grout: Part[] = [];
    // Two grout lines each way, flush overlays on the slab top.
    for (const offset of [-1 / 6, 1 / 6]) {
      grout.push({
        geometry: new THREE.BoxGeometry(1.0, 0.012, 0.02),
        color: GROUT,
        position: [0, 0.06, offset],
      });
      grout.push({
        geometry: new THREE.BoxGeometry(0.02, 0.012, 1.0),
        color: GROUT,
        position: [offset, 0.06, 0],
      });
    }
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 1.0), color: CERAMIC, position: [0, 0.03, 0] },
      ...grout,
    ];
  },
  animations: [],
});
